import React, {useEffect} from 'react'
import apiClient from '../http-common';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { setTraders } from './tradersSlice';

export const FetchTraders = () => {
  const dispatch = useDispatch();
    const { isLoading: isLoadingProducts, refetch: getProducts } = useQuery(
        "show-traders",
        async () => {
          return await apiClient.get("/api/show-traders");
        },
        {
          enabled: true,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                dispatch(setTraders(res.data.traders));
                const event = new Event('updatedStorage');
                window.dispatchEvent(event);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

      useEffect(() => {
        getProducts();
      }, []);
 
}

export default FetchTraders
